const DUMMY_USERS = {
  email: "thunderbay.admin@gmail.com",
  password: "Staffnosee123!",
  role: "admin",
};

export const authoriseUser = (email, password) => {
  let res = {};

  if (email === DUMMY_USERS.email && password === DUMMY_USERS.password) {
    res.data = DUMMY_USERS;
    res.error = false;
  } else {
    res.data = {};
    res.error = true;
  }
  return res;
};
